import React from 'react';
import cmsUtils from '../../utils/cmsUtils';
import { Item } from '../../items/item';
import utils from '../../../utils';
import './style.scss';
import { useMediaQuery } from 'react-responsive';

export function MultiColumnPanelNew(props) {
    const item = props.item;
    const mobileReverse = cmsUtils.payload(item, 'MobileReverse', 'no');
    //const subItems = item.items || [];
    const subItems = (mobileReverse === "yes" && utils.css.screenWidth() <= 550) ? item.items.reverse() || [] : item.items || [];
    const cmsOption = props.cmsOption || {};

    const columnLaptop = cmsUtils.payload(item, 'ColumnNumber');
    const columnMobile = cmsUtils.payload(item, 'ColumnNumberM');
    const isMobile = useMediaQuery({ maxWidth: 767.99 });

    const bgColor = cmsUtils.payload(item, 'BgColor');
    //const textColorTheme = cmsUtils.payload(item, 'TextColorTheme');
    const imageUrl = cmsUtils.payload(item, 'ImageUrl');
    const backgroundTile = cmsUtils.payload(item, 'BackgroundTile');
    const bgTheme = cmsUtils.payload(item, 'TextColorTheme') || 'white';

    console.log("columnmunber", columnLaptop);

    let bgUrl = null;
    if (imageUrl)
        bgUrl = utils.site.resourcePath(imageUrl);
    else if (backgroundTile)
        bgUrl = utils.site.resourcePath(`/dist/transparent-textures/textures/${backgroundTile}`);


    const cssClass = utils.classNames('cms_item', 'contentPanel', 'multiColumnPanel', 'multiColumnPanelNew', 'contentPanel--' + bgTheme, item.cssClass || item.anchorName || '');

    const getColumnClass = () => {
        if (columnLaptop === "1" || isMobile) {
            return "single-column";
        } else if (columnLaptop === "2") {
            return "double-column";
        }
    };

    const subItemsElts = subItems.map((subItem, index) => (
        <div
            className={`${getColumnClass()}`} 
            key={subItem.itemId}
        >
            <Item item={subItem} cmsOption={cmsOption} />
        </div>
    ));

    console.log("isMobile:", isMobile);

    return (
        <section className={cssClass} style={{
            backgroundColor: `${bgColor}`,
            backgroundImage: bgUrl && utils.css.bgUrlStyle(bgUrl)
        }} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
            <div className="container">
                {(columnLaptop === 1 || isMobile) ? (
                    <div className='single-column-container'>
                        {subItemsElts}
                    </div>
                ) : (
                    <div className='double-column-container'>
                        {subItemsElts}
                    </div>
                )}
            </div>
        </section>
    );
}